import axios from "axios";
import config from "../config";

interface LoggedInResponse {
  loggedIn: boolean;
}

export default async function TestLogin() {
  let isLoggedIn = false;

  if (!config.useFakeModels) {
    try {
      const response = await axios.get<LoggedInResponse>(
        config.testLoginEndpoint
      );
      if (response?.data?.loggedIn) {
        isLoggedIn = true;
      }
    } catch (e) {
      console.error("There was an error!", e);
    }
  } else {
    isLoggedIn = true;
  }

  return isLoggedIn;
}
